// eslint-disable-next-line camelcase
export const action_types = {
  REQUEST_GIFT: 'REQUEST_GIFT',
  SUCCESS_GIFT: 'SUCCESS_GIFT',
  ERROR_GIFT: 'ERROR_GIFT'
}